import { Box, Typography } from "@mui/material";
import type { ICellRendererParams } from "ag-grid-community";
import { getAssetColor } from "@/shared/utils/assets";
import { type BreakGridRow, groupKind } from "../utils/gridRows";

const Dot = ({ color }: { color: string }) => (
	<Box
		component="span"
		sx={{
			display: "inline-block",
			width: 10,
			height: 10,
			borderRadius: "50%",
			backgroundColor: color,
			mr: 1,
		}}
	/>
);

export const GroupCellRenderer = (
	params: ICellRendererParams<BreakGridRow>,
) => {
	const first = params.node.allLeafChildren?.[0]?.data;
	if (!first) return null;
	const kind = groupKind(params.node);

	if (kind === "area") {
		return (
			<>
				<Dot
					color={getAssetColor({
						AssetId: first.ParentAssetId ?? 0,
						ParentAssetId: null,
					})}
				/>
				{first.ParentAssetName ?? "Other"}
			</>
		);
	}

	if (kind === "line") {
		return (
			<>
				<Dot color={getAssetColor(first)} />
				{first.AssetName}
			</>
		);
	}

	const hours = params.node.key?.replace("h", "");
	return (
		<Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: 2 }}>
			<span>{hours}h shifts</span>
			{Number(hours) === first.DefaultShiftHours && (
				<Typography
					component="span"
					variant="caption"
					sx={{
						ml: "auto",
						mr: 1,
						color: "text.disabled",
						fontStyle: "italic",
					}}
				>
					line default
				</Typography>
			)}
		</Box>
	);
};
